import { MatSnackBar } from "@angular/material/snack-bar";
import { Injectable } from "@angular/core";
import { EnvService } from "./env.service";

@Injectable({
  providedIn: "root",
})
export class SnackBarService {
  timeoutDoToast;
  duracaoSnack;

  constructor(private snack: MatSnackBar, env: EnvService) {
    this.timeoutDoToast = env.timeoutToast;
    this.duracaoSnack = env.timeoutSnack;
  }

  abrirSnackBarErro(pMsg: string) {
    setTimeout(() => {
      this.snack.open(pMsg, "", {
        duration: this.duracaoSnack,
        panelClass: ["red-snackbar"],
      });
    });
  }

  abrirSnackBar(pMsg: string) {
    setTimeout(() => {
      this.snack.open(pMsg, "", {
        duration: this.duracaoSnack,
      });
    });
    /*
    let snackBarRef =
    if (!pDesfazendo) {
      snackBarRef.onAction().subscribe(() => {
        this.onUndo();
      });
    }

    snackBarRef.afterDismissed().subscribe(() => {
      this.atualiarRegistroParaDesfazer(
        this.form.value.id,
        this.form.value.dsNome,
        this.form.value.dsHistorico,
        this.form.value.dsSigla
      );
    });*/
  }
}
